import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import ClickOutside from 'vuetify/lib/directives/click-outside';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VTooltip,
    {
      attrs: {
        "open-on-hover": !_setup.isMobile,
        "open-on-click": false,
        "open-on-focus": false,
        bottom: "",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "span",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          def: ClickOutside,
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _setup.onClickOutside,
                          expression: "onClickOutside",
                        },
                      ],
                      staticClass:
                        "lpu-license-badge d-inline-flex align-center justify-center ml-1 cursor-pointer",
                      attrs: {
                        "data-qa": _vm.qa,
                        role: "button",
                        tabindex: "0",
                        "aria-label": _vm.text,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _setup.onBadgeClick.apply(null, arguments)
                        },
                      },
                    },
                    "span",
                    attrs,
                    false
                  ),
                  _setup.isMobile ? {} : on
                ),
                [
                  _c(
                    VIcon,
                    {
                      staticClass: "lpu-license-badge__icon",
                      attrs: { color: "success", size: "18" },
                    },
                    [_vm._v("\n        ui-icon-shield-checkmark-40\n      ")]
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _setup.isOpen,
        callback: function ($$v) {
          _setup.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "text-body-1 bg-gray-0--text" }, [
        _vm._v("\n    " + _vm._s(_vm.text) + "\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }